import { Text, Container, useMediaQuery } from '@podiumhq/design-system';

import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

import {
  MONTHLY_TERM,
  PLAN_PACKAGES,
  YEARLY_TERM,
} from '../PricingPackaging/constants';
import {
  SelectPlanCardsAndList,
  useSelectPlanTrackEvents,
} from '../PricingPackaging/SelectPlan';

import { CheckoutTitle } from './components/layout';
import { PAYMENT_VIEW_ROUTE } from './constants';

const SelectPlanView = () => {
  const [isSmallerThan1180px] = useMediaQuery('(max-width: 1180px)');
  const {
    changeCheckoutPage,
    orgPricePackages = {},
    selectedPlan = {},
    selectedTerm,
    setSelectedPlan,
    setSelectedTerm,
  } = useCheckoutContext();
  const { bundleCardCtaTrackEvent, onToggleFeatureList, trackPlanTermToggle } =
    useSelectPlanTrackEvents();

  const bundleCardCta = (bundleName) => {
    bundleCardCtaTrackEvent(bundleName, selectedTerm);

    const plan = PLAN_PACKAGES[bundleName];
    const annualPrice = orgPricePackages[YEARLY_TERM][plan.plan];
    const monthlyPrice = orgPricePackages[MONTHLY_TERM][plan.plan];

    setSelectedPlan({ ...plan, annualPrice, monthlyPrice });

    changeCheckoutPage(PAYMENT_VIEW_ROUTE);
  };

  const handleMonthlyChange = (index) => {
    trackPlanTermToggle(!index);
    setSelectedTerm(index ? MONTHLY_TERM : YEARLY_TERM);
  };

  return (
    <Container maxW="container.xl">
      <CheckoutTitle>Pick your plan.</CheckoutTitle>

      <Text color="black.base" fontSize="lg" fontWeight="normal" mb="40px">
        Find the perfect plan for your business.
      </Text>

      <SelectPlanCardsAndList
        canChoosePlan={true}
        currentPlan={selectedPlan?.plan}
        handleTabChange={handleMonthlyChange}
        isMobileView={isSmallerThan1180px}
        monthlyPackagePrices={orgPricePackages[MONTHLY_TERM]}
        onBundleCardCtaOnClick={bundleCardCta}
        onToggleFeatureList={onToggleFeatureList}
        priceTerm={selectedTerm}
        yearlyPackagePrices={orgPricePackages[YEARLY_TERM]}
      />
    </Container>
  );
};

export default SelectPlanView;
